import { Pipe, PipeTransform } from '@angular/core';
import { EAnnouncementAcknowledgeButtonText } from '@backend/models/types/announcement';

@Pipe({
  name: 'announcementAcknowledgeButtonText',
  standalone: true
})
export class AnnouncementAcknowledgeButtonTextPipe implements PipeTransform {
  public transform(
    acknowledgeButtonText: EAnnouncementAcknowledgeButtonText
  ): string {
    switch (acknowledgeButtonText) {
      case EAnnouncementAcknowledgeButtonText.ACKNOWLEDGE:
        return 'Acknowledge';
      case EAnnouncementAcknowledgeButtonText.COMPLETE:
        return 'Complete';
      default:
        return 'Understand and Agree';
    }
  }
}
